import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop, upperFirst } from 'lodash';
import OutsideClickHandler from 'react-outside-click-handler';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import DoneIcon from '@material-ui/icons/Done';
import { IconButton } from '@material-ui/core';

import { ConfirmAction } from 'components';
import { isMobile } from 'helpers/detect-mobile';

const styles = () => ({
  button: {
    backgroundColor: 'transparent',
    border: '1px solid #09f',
    borderRadius: 5,
    boxShadow: 'none',
    marginBottom: 5,
  },
  buttonLabel: {
    color: '#09f',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'none',
  },
  chip: {
    backgroundColor: '#ebebeb',
    border: '1px solid #ababab',
    marginRight: 5,
    marginBottom: 5,
  },
  chipLarge: { color: '#6c6c6c' },
  chipMedium: {
    color: '#6c6c6c',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '28px',
    paddingLeft: 9,
    paddingRight: 9,
  },
  chipSmall: {
    borderRadius: 3,
    color: '#6c6c6c',
    fontSize: 12,
    fontWeight: 600,
    height: 20,
    lineHeight: '20px',
    paddingLeft: 5,
    paddingRight: 5,
  },
  chipDeleteIcon: {
    color: 'gray',
    fill: 'darkgray',
    height: isMobile ? 25 : 19,
    margin: isMobile ? '0px 4px 0px 8px' : '0px 4px 0px -4px',
    width: isMobile ? 25 : 19,
  },
  chipDeleteIconInside: {
    height: isMobile ? 25 : 19,
    width: isMobile ? 25 : 19,
  },
  textField: { marginRight: 10 },
});

class TagsInpput extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    prefix: PropTypes.string,
    size: PropTypes.oneOf([
      'small',
      'medium',
      'large',
    ]),
    tags: PropTypes.arrayOf(PropTypes.string),
    formatMessage: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    onEditTag: PropTypes.func,
  };

  static defaultProps = {
    prefix: '',
    size: 'medium',
    tags: [],
    onEditTag: noop,
    onChange: noop,
  };

  static contextTypes = {
    readOnly: PropTypes.bool,
  };

  state = {
    newTag: '',
    editing: false,
    editIndex: null,
    newValue: '',
  };

  onAddTag = () => {
    const { onChange, prefix, tags } = this.props;
    const { newTag } = this.state;

    if (tags.indexOf(newTag) !== -1 || !newTag) return;

    this.setState({ newTag: '' });
    onChange(tags.concat([`${prefix}${newTag}`]));
  }

  onChangeNewTag = ({ target: { value } }) => {
    this.setState({ newTag: value });
  }

  onRequestDelete = (index) => {
    const { onChange } = this.props;
    const tags = this.props.tags.slice();
    tags.splice(index, 1);
    onChange(tags);
  }

  onClickIcon = (index) => {
    const { onEditTag, tags, prefix } = this.props;
    const { editing, newValue } = this.state;
    if (!editing) {
      this.onRequestDelete(index);
      return;
    }
    onEditTag(
      tags[index],
      prefix,
      newValue,
      () => this.setState({ editing: false, editIndex: null, newValue: '' }));
  }

  onClickChip = (index) => {
    const { tags, prefix } = this.props;
    this.setState({ editing: true, editIndex: index, newValue: tags[index].substr(prefix.length) });
  };

  cancelEdit = () => this.setState({ editing: false, editIndex: null, newValue: '' });

  render() {
    const {
      classes,
      prefix,
      size,
      tags,
      formatMessage,
    } = this.props;
    const { readOnly } = this.context;
    const { newTag, editing, newValue, editIndex } = this.state;
    return (
      <div className="form-field group-add">
        <div className="fields">
          <TextField
            className={classes.textField}
            disabled={readOnly}
            name="tags-input"
            onChange={this.onChangeNewTag}
            onKeyPress={(e) => {
              if (e.which === 13) {
                this.onAddTag();
              }
            }}
            placeholder={formatMessage('Add New Group')}
            value={newTag}
            variant="outlined"
          />
          <Button
            classes={{
              label: classes.buttonLabel,
              root: classes.button,
            }}
            onClick={this.onAddTag}
            variant="contained"
          >
            {formatMessage('Save')}
          </Button>
        </div>
        <div className="row no-margin">
          {tags.length ? tags.map((tag, index) => (
            tag.startsWith(prefix)
              ? (
                <OutsideClickHandler
                  key={index}
                  onOutsideClick={this.cancelEdit}
                >
                  <Chip
                    classes={{
                      deleteIcon: classes.chipDeleteIcon,
                      root: classes.chip,
                      label: classes[`chip${upperFirst(size)}`],
                    }}
                    deleteIcon={(
                      <ConfirmAction
                        action={readOnly || editing ? null : () => this.onRequestDelete(index)}
                        description={formatMessage('Do you really want to delete this group?')}
                        onClick={e => e.stopPropagation()}
                      >
                        <CancelIcon className={classes.chipDeleteIconInside} />
                      </ConfirmAction>
                    )}
                    label={
                      editing && editIndex === index ?
                        <Fragment>
                          <TextField
                            autoFocus
                            value={newValue}
                            onKeyPress={(e) => {
                              if (e.which === 13) {
                                this.onClickIcon(index);
                              }
                            }}
                            onChange={e => this.setState({ newValue: e.target.value })}
                          />
                          <IconButton onClick={() => this.onClickIcon(index)}>
                            <DoneIcon />
                          </IconButton>
                        </Fragment>
                      : tag.substr(prefix.length)
                    }
                    onDelete={noop}
                    onClick={readOnly ? null : () => this.onClickChip(index)}
                  />
                </OutsideClickHandler>
              ) : null
            )) : null}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(TagsInpput);
